import React from 'react';
import cx from 'classnames';
import Slider from 'react-slick/lib';
import './Slider.scss';

const _Slider = (props) => {
  const {
    className,
    emptyText,
    list,
    item,
    dots = true,
    adaptiveHeight = false,
    infinite = true,
    slidesToShow = 1,
    ...res
  } = props;
  return (
    <Slider
      className={cx('amondz-slider', className)}
      dots={dots}
      infinite={infinite}
      focusOnSelect={true}
      speed={500}
      slidesToShow={slidesToShow}
      slidesToScroll={1}
      adaptiveHeight={adaptiveHeight}
      {...res}
    >
      {list && list.length ? (
        list.map((data, index) => (
          <span data-index={index} key={index}>
            {item(data)}
          </span>
        ))
      ) : (
        <div className="empty">
          <span>{emptyText}</span>
        </div>
      )}
    </Slider>
  );
};

export default _Slider;
